import { IAuthenticatedUser } from '../domain/AuthenticatedUser';
import { ITableInfo } from '../domain/Table';
import { IClientList } from '../domain/Client';
import { IMobileApp } from '../domain/MobileApp';

import axios from 'axios';

export interface IDataAccessService
{
    rootUrl: string;
    deviceInformation: string;
    getMobileAppDetails(): Promise<{}>;
    getAuthorizedClients(token: string, 
                         securityObjectValue: string, 
                         securityActionValue: string, 
                         securityLevelValue: string): Promise<{}>;
    authenticateUser(data: {}): Promise<{}>;
    getBerthList(token: string, searchType: string, clientID: string, searchText: string, 
                 latitude: string, longitude: string): Promise<{}>;
    getBerth(token: string, berthId: string): Promise<{}>;
    getFields(token: string): Promise<{}>;
	putFields(token: string, data: ITableInfo[]): Promise<{}>
    getActivityLogList(token: string, clientID: string, periodType: string, startDate:string, endDate:string, searchPerson: string, 
                       searchText: string,  getActivityTypeId: number, pinned:boolean, personID: string, 
                       isOpen: boolean): Promise<{}>;
    getActivityTypeList(token: string, clientID: string): Promise<{}>;
    getCategoryList(token: string, clientID: string): Promise<{}>;
    getLocationList(token: string, clientID: string): Promise<{}>;
    putActivityLog(token: string, data: string): Promise<{}>;
    deleteActivityLog(token: string, activityLogID: string): Promise<{}>;
    getActivityLogById(token: string, activityLogId: string ): Promise<{}>;
    getSeas(token: string): Promise<{}>;
    updateActivityLog(token: string, activityLogId: string, endDateTime: string): Promise<{}>; 
    putPerson(token: string, data: string): Promise<{}>;
}

export interface IAuthenticatedUserResource extends IAuthenticatedUser { }
export interface IMobileAppResource extends IMobileApp { }
export interface IClientListResource extends IClientList { }

interface authData {
    username: string;
    password: string;
    grant_type: string;
}
export class DataAccessService implements IDataAccessService
{
    rootUrl: string;
    deviceInformation: string;
        
    constructor() {
        if (((window as any).env  && (window as any).env?.REACT_APP_ENV) && (window as any).env?.REACT_APP_API_URL) { 
            this.rootUrl = (window as any).env?.REACT_APP_API_URL;
        }  
        else {
            //this.rootUrl = "https://api.onlinemooring.com";       //production secure domain
            //this.rootUrl = "https://my.onlinemooring.com:1033";   //production secure
            //this.rootUrl = "http://my.onlinemooring.com:1032";    //production 

            this.rootUrl = "https://apitest.onlinemooring.com";   //test secure domain
            //this.rootUrl = "https://my.onlinemooring.com:1031";   //test secure
            //this.rootUrl = "http://my.onlinemooring.com:1030";    //test
            
            //this.rootUrl = "http://localhost:60274";              //localhost
            //this.rootUrl = "http://api.om.com";                   //local IIS
        }

        this.deviceInformation = String(window.localStorage.getItem("platform")) + " " 
                                + String(window.localStorage.getItem("model"));
    }

    public getMobileAppDetails(): Promise<{}>
    {
        let _this = this;
        let config = {};
              
        return axios.get(_this.rootUrl + '/MobileApp/1', config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                return "Data: " + error.data + 
                        "<hr />status: " + error.status + 
                        "<hr />headers: " + error.header + "<hr />config: " + config;
        });
    }

    authenticateUser(data:authData): Promise<{}>
    {
        let serializeEncodedData: string;
        let str = [];
        let _this = this;
        str.push(encodeURIComponent("username") + "=" + encodeURIComponent(data.username));
        str.push(encodeURIComponent("password") + "=" + encodeURIComponent(data.password));
        str.push(encodeURIComponent("grant_type") + "=" + encodeURIComponent(data.grant_type));
        serializeEncodedData = str.join("&");

        let config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;' } }

        return axios.post(_this.rootUrl + "/token", serializeEncodedData, config)
            .then((response) => {
                return response?.data;
            },
            (error) => {
                return (error as any)?.response?.data;
            });
    }

    public getAuthorizedClients(token: string, 
                            securityObjectValue: string, 
                            securityActionValue: string, 
                            securityLevelValue: string ): Promise<{}>
    {
        let _this = this;
        let config = { headers: { 'Authorization': 'Bearer ' + token } };
           
        return axios.get(_this.rootUrl + "/AuthorizedClients/" + securityObjectValue 
                            + "/" + securityActionValue 
                            + "/" + securityLevelValue, config)
            .then((response) => {
                return response?.data;
            },
            (error) => {
                return "Data: " + error.data
                         +  "<hr />status: " + error.status 
                         + "<hr />headers: " + error.header 
                         + "<hr />config: " + config;
            });
    }

//#region "Berth"
    getBerthList(token: string, searchType: string, clientID: string, 
                    searchText: string, latitude: string, longitude: string): Promise<{}>
    {
        let _this = this;

        let config = { headers: { 'Authorization': 'Bearer ' + token } };
        let addsearchText;
        let addlatitude;
        let addlongitude;
        if (searchText === '') 
            addsearchText = '"';
        else
            addsearchText = '';

        if (latitude === '')
            addlatitude = '"';
        else
            addlatitude = '';

        if (longitude === '')
            addlongitude = '"';
        else
            addlongitude = '';

        return axios.get(_this.rootUrl + '/BerthSearch/' 
                                        + searchType + '/' 
                                        + clientID + '/'
                                        + addsearchText + searchText + addsearchText  + '/'
                                        + addlatitude + latitude + addlatitude + '/'
                                        + addlongitude + longitude + addlongitude + '/'
                                        + addsearchText + _this.deviceInformation + addsearchText + '/', config)
               .then((response) => {
                   return response.data;
               },
                (error) => {
                   return "Data: " + error.data 
                        + "<hr />status: " + error.status 
                        + "<hr />headers: " + error.header 
                        + "<hr />config: " + config;
               });
    }

    getBerth(token: string, berthId: string): Promise<{}> {
        let _this = this;
        let config = { headers: { 'Authorization': 'Bearer ' + token } };

        return axios.get(_this.rootUrl + "/Berth/" + berthId, config)
               .then((response) => {
                   return response.data;
               },
               (error) => {
                   return "Data: " + error.data 
                        + "<hr />status: " + error.status 
                        + "<hr />headers: " + error.header 
                        + "<hr />config: " + config;
               });
    }
//#endregion "Berth"

//#region "Fields"
    getFields(token: string): Promise<{}> {
        let _this = this;
        let config = { headers: { 'Authorization': 'Bearer ' + token } };

        return axios.get(_this.rootUrl + "/Fields", config)
               .then((response) => {
                   return response.data;
               },
               (error) => {
                   return "Data: " + error.data 
                            + "<hr />status: " + error.status 
                            + "<hr />headers: " + error.header 
                            + "<hr />config: " + config;
               });
    }

    putFields(token: string, data: ITableInfo[] ): Promise<{}> {
        let _this = this;
        let config = { headers: { 'Authorization': 'Bearer ' + token } };
           
        let jsonDataString = '{"Tables":' + JSON.stringify(data) + '}';
        let jsonData = JSON.parse(jsonDataString);
        return axios.put(_this.rootUrl + "/Fields/", jsonData, config)
               .then((response) => {
                   return response.data;
               },
               (error) => {
                   return "Data: " + error.data 
                            + "<hr />status: " + error.status 
                            + "<hr />headers: " + error.header 
                            + "<hr />config: " + config;
               });
    }
//#endregion "Fields"

//#region "Activity Log Table operations"

    getActivityLogList(token: string, clientID: string, periodType: string, startDate: string, 
                    endDate: string, searchPerson: string, searchText: string, 
                    getActivityTypeId: number, pinned:boolean, personID: string, isOpen: boolean ): Promise<{}> {
		let _this = this;

        let config = { headers: {'Authorization': 'Bearer ' + token }};
        let newsearchText;
		let newaddsearchPerson;
        let lpinned;
        let lisOpen;
        let lstartDate;
        let lendDate;

		if (searchText === '')
            newsearchText = "null";
		else
            newsearchText = searchText;

		if (searchPerson === "2")
            newaddsearchPerson = "null";
		else
            newaddsearchPerson = searchPerson;

        lpinned = pinned.toString();
        lisOpen = isOpen.toString();
        
        if (personID ==='') {
            personID = "-1";
        }
       
        if (startDate === '')
            lstartDate = "null";
        else
            lstartDate = startDate;

        if (endDate === '') 
            lendDate = "null";
        else
            lendDate = endDate;
            
        //console.log(newsearchText);
        return axios.get(_this.rootUrl + '/ActivityLogSearch/' 
                + clientID + '/' 
                + periodType + '/'
                + lstartDate + '/'
                + lendDate + '/'
                + newaddsearchPerson + '/'
                + newsearchText + '/' 
                + getActivityTypeId.toString() + '/'
                + lpinned + '/' 
                + personID + '/'
                + lisOpen + '/'
                + 'Android/', config)
			   .then((response) => {
				   return response.data;
			   },
			   (error) => {
                   return "Data: " + error.data 
                   + "<hr />status: " + error.status 
                   + "<hr />headers: " + error.header 
                   + "<hr />config: " + config;
               }
        );
    }

    getActivityLogById(token: string, activityLogId: string ): Promise<{}> {
        let _this = this;
      
        let config = { headers: { 'Authorization': 'Bearer ' + token } };

        return axios.get(_this.rootUrl + '/ActivityLogSearchGet/' + activityLogId, config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                return "Data: " + error.data 
                        + "<hr />status: " + error.status 
                        + "<hr />headers: " + error.header 
                        + "<hr />config: " + config;
        });
    }

    putActivityLog(token: string, data: string): Promise<{}> {
        let _this = this;
        let config = { headers: { 'Authorization': 'Bearer ' + token } };
    
        let jsonData = JSON.parse(data);
        return axios.put(_this.rootUrl + "/ActivityLogSearchPut/", jsonData, config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                return "Data: " + error.data 
                            + "<hr />status: " + error.status 
                            + "<hr />headers: " + error.header 
                            + "<hr />config: " + config;
            });
    }
    
    deleteActivityLog(token: string, activityLogID: string) {
           let _this = this;
           let config = { headers: { 'Authorization': 'Bearer ' + token } };
    
           return axios.delete(_this.rootUrl + '/ActivityLogSearchDelete/' 
                                + activityLogID + '/', config)
               .then((response) => {
                   return response.data;
               },
               (error) => {
                   return "Data: " + error.data 
                    + "<hr />status: " + error.status 
                    + "<hr />headers: " + error.header + "<hr />config: " + config;
               });
    }

    updateActivityLog(token: string, activityLogId: string,  endDateTime: string): Promise<{}> {
        let _this = this;
        let config = { headers: { 'Authorization': 'Bearer ' + token } };
        // + endDateTime + "/"
        return axios.get(_this.rootUrl + "/ActivityLogSearchUpdate/" + activityLogId + "/", config)
            .then((response) => {
                return response;
            },
            (error) => {
                return "Data: " + error.data 
                            + "<hr />status: " + error.status 
                            + "<hr />headers: " + error.header 
                            + "<hr />config: " + config;
            });
    }

//#endregion "Activity Log Table operations"

//#region "Person table operations"
    putPerson(token: string, data: string): Promise<{}> {
        let _this = this;
        let config = { headers: { 'Authorization': 'Bearer ' + token } };

        let jsonData = JSON.parse(data);
        return axios.put(_this.rootUrl + "/PersonPut/", jsonData, config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                return "Data: " + error.data 
                            + "<hr />status: " + error.status 
                            + "<hr />headers: " + error.header 
                            + "<hr />config: " + config;
            });
    }
//#endregion "Person Table operations"

//#region "Boat table operations"
    putBoat(token: string, data: string): Promise<{}> {
        let _this = this;
        let config = { headers: { 'Authorization': 'Bearer ' + token } };

        let jsonData = JSON.parse(data);
        return axios.put(_this.rootUrl + "/BoatPut/", jsonData, config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                return "Data: " + error.data 
                            + "<hr />status: " + error.status 
                            + "<hr />headers: " + error.header 
                            + "<hr />config: " + config;
            });
    }
//#endregion "Boat Table operations"

//#region "Vehicle table operations"
    putVehicle(token: string, data: string): Promise<{}> {
        let _this = this;
        let config = { headers: { 'Authorization': 'Bearer ' + token } };

        let jsonData = JSON.parse(data);
        return axios.put(_this.rootUrl + "/VehiclePut/", jsonData, config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                return "Data: " + error.data 
                            + "<hr />status: " + error.status 
                            + "<hr />headers: " + error.header 
                            + "<hr />config: " + config;
            });
    }
//#endregion "Vehicle Table operations"

//#region "ViolationType operations"
    putViolationType(token: string, data: string): Promise<{}> {
        let _this = this;
        let config = { headers: { 'Authorization': 'Bearer ' + token } };

        let jsonData = JSON.parse(data);
        return axios.put(_this.rootUrl + "/ViolationTypePut/", jsonData, config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                return "Data: " + error.data 
                            + "<hr />status: " + error.status 
                            + "<hr />headers: " + error.header 
                            + "<hr />config: " + config;
            });
    }
//#endregion

//#region "Configuration Tabels For Client"

    getEquipmentList(token: string): Promise<{}> {
        let _this = this;
        let config = { headers: { 'Authorization': 'Bearer ' + token } };
         
        return axios.get(_this.rootUrl + '/Equipment', config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                throw new Error("Data: " + error.data 
                    + "<hr />status: " + error.status 
                    + "<hr />headers: " + error.header 
                    + "<hr />config: " + config);
            });
    }

    getEquipmentTypes(token: string): Promise<{}> {
        let _this = this;
        let config = { headers: { 'Authorization': 'Bearer ' + token } };
         
        return axios.get(_this.rootUrl + '/EquipmentTypes', config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                throw new Error("Data: " + error.data 
                    + "<hr />status: " + error.status 
                    + "<hr />headers: " + error.header 
                    + "<hr />config: " + config);
            });
    }

    getEquipmentInspectionPoints(token: string): Promise<{}> {
        let _this = this;
        let config = { headers: { 'Authorization': 'Bearer ' + token } };
         
        return axios.get(_this.rootUrl + '/EquipmentInspectionPoints', config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                throw new Error("Data: " + error.data 
                    + "<hr />status: " + error.status 
                    + "<hr />headers: " + error.header 
                    + "<hr />config: " + config);
            });
    }

    getSafetyChecks(token: string): Promise<{}> {
        let _this = this;
        let config = { headers: { 'Authorization': 'Bearer ' + token } };
         
        return axios.get(_this.rootUrl + '/SafetyCheck', config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                throw new Error("Data: " + error.data 
                    + "<hr />status: " + error.status 
                    + "<hr />headers: " + error.header 
                    + "<hr />config: " + config);
            });
    }

    getViolationTypes(token: string): Promise<{}> {
        let _this = this;
        let config = { headers: { 'Authorization': 'Bearer ' + token } };
         
        return axios.get(_this.rootUrl + '/ViolationType', config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                throw new Error("Data: " + error.data 
                    + "<hr />status: " + error.status 
                    + "<hr />headers: " + error.header 
                    + "<hr />config: " + config);
            });
    }

//#endregion "Configuration Tabels For Client"

//#region "Related to Activity Log Entries"
    getUserList(token: string): Promise<{}> {
        let _this = this;
        let config = { headers: { 'Authorization': 'Bearer ' + token } };
        
        return axios.get(_this.rootUrl + '/User', config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                throw new Error("Data: " + error.data 
                    + "<hr />status: " + error.status 
                    + "<hr />headers: " + error.header 
                    + "<hr />config: " + config);
            });
    }

    getPersonList(token: string): Promise<{}> {
        let _this = this;
        let config = { headers: { 'Authorization': 'Bearer ' + token } };
        
        return axios.get(_this.rootUrl + '/Person', config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                throw new Error("Data: " + error.data 
                    + "<hr />status: " + error.status 
                    + "<hr />headers: " + error.header 
                    + "<hr />config: " + config);
            });
    }

    getBoatList(token: string): Promise<{}> {
        let _this = this;
        let config = { headers: { 'Authorization': 'Bearer ' + token } };
        
        return axios.get(_this.rootUrl + '/Boat', config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                throw new Error("Data: " + error.data 
                    + "<hr />status: " + error.status 
                    + "<hr />headers: " + error.header 
                    + "<hr />config: " + config);
            }
        );
    }

    getRegBoatList(token: string) :Promise<{}>{
        let _this = this;
        let config = { headers: { 'Authorization': 'Bearer ' + token } };
        
        return axios.get(_this.rootUrl + '/RegBoat', config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                throw new Error("Data: " + error.data 
                    + "<hr />status: " + error.status 
                    + "<hr />headers: " + error.header 
                    + "<hr />config: " + config);
            }
        );
    }

    getVehicleList(token: string): Promise<{}> {
        let _this = this;
        let config = { headers: { 'Authorization': 'Bearer ' + token } };
        
        return axios.get(_this.rootUrl + '/Vehicle', config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                throw new Error("Data: " + error.data 
                    + "<hr />status: " + error.status 
                    + "<hr />headers: " + error.header 
                    + "<hr />config: " + config);
            }
        );
    }
//#endregion "Related to Activity Log Entries"

//#region "Configuration Field Values"
    getActivityTypeList(token: string): Promise<{}> {
        let _this = this;

        let config = { headers: { 'Authorization': 'Bearer ' + token } };
         
        return axios.get(_this.rootUrl + '/ActivityTypeSearch', config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                throw new Error("Data: " + error.data 
                    + "<hr />status: " + error.status 
                    + "<hr />headers: " + error.header 
                    + "<hr />config: " + config);
            });
    }

    getCategoryList(token: string): Promise<{}> {
        let _this = this;

        let config = { headers: { 'Authorization': 'Bearer ' + token } };
         
        return axios.get(_this.rootUrl + '/CategorySearch', config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                throw new Error("Data: " + error.data 
                    + "<hr />status: " + error.status 
                    + "<hr />headers: " + error.header 
                    + "<hr />config: " + config);
            });
    }

    getLocationList(token: string): Promise<{}> {
        let _this = this;

        let config = { headers: { 'Authorization': 'Bearer ' + token } };
         
        return axios.get(_this.rootUrl + '/LocationSearch', config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                throw new Error("Data: " + error.data 
                    + "<hr />status: " + error.status 
                    + "<hr />headers: " + error.header 
                    + "<hr />config: " + config);
            });
    }

//#endregion "Configuration Field Values"

//#region "Reference Tables"
    getSeas(token: string): Promise<{}> {
        let _this = this;

        let config = { headers: { 'Authorization': 'Bearer ' + token } };
         
        return axios.get(_this.rootUrl + '/Seas', config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                throw new Error("Data: " + error.data 
                    + "<hr />status: " + error.status 
                    + "<hr />headers: " + error.header 
                    + "<hr />config: " + config);
            });
    }

    getWinds(token: string): Promise<{}> {
        let _this = this;

        let config = { headers: { 'Authorization': 'Bearer ' + token } };
         
        return axios.get(_this.rootUrl + '/Winds', config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                throw new Error("Data: " + error.data 
                    + "<hr />status: " + error.status 
                    + "<hr />headers: " + error.header 
                    + "<hr />config: " + config);
            });
    }

    getWeather(token: string): Promise<{}> {
        let _this = this;

        let config = { headers: { 'Authorization': 'Bearer ' + token } };
         
        return axios.get(_this.rootUrl + '/Weather', config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                throw new Error("Data: " + error.data 
                    + "<hr />status: " + error.status 
                    + "<hr />headers: " + error.header 
                    + "<hr />config: " + config);
            });
    }

    getEquipmentStatuses(token: string): Promise<{}> {
        let _this = this;

        let config = { headers: { 'Authorization': 'Bearer ' + token } };
         
        return axios.get(_this.rootUrl + '/EquipmentStatuses', config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                throw new Error("Data: " + error.data 
                    + "<hr />status: " + error.status 
                    + "<hr />headers: " + error.header 
                    + "<hr />config: " + config);
            });
    }

    getIncidentDispositions(token: string): Promise<{}> {
        let _this = this;

        let config = { headers: { 'Authorization': 'Bearer ' + token } };
         
        return axios.get(_this.rootUrl + '/IncidentDispositions', config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                throw new Error("Data: " + error.data 
                    + "<hr />status: " + error.status 
                    + "<hr />headers: " + error.header 
                    + "<hr />config: " + config);
            });
    }

    getActivityLogRoles(token: string): Promise<{}> {
        let _this = this;

        let config = { headers: { 'Authorization': 'Bearer ' + token } };
         
        return axios.get(_this.rootUrl + '/ActivityLogRole', config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                throw new Error("Data: " + error.data 
                    + "<hr />status: " + error.status 
                    + "<hr />headers: " + error.header 
                    + "<hr />config: " + config);
            });
    }

    getDeliveryMethods(token: string): Promise<{}> {
        let _this = this;
        let config = { headers: { 'Authorization': 'Bearer ' + token } };
         
        return axios.get(_this.rootUrl + '/DeliveryMethod', config)
            .then((response) => {
                return response.data;
            },
            (error) => {
                throw new Error("Data: " + error.data 
                    + "<hr />status: " + error.status 
                    + "<hr />headers: " + error.header 
                    + "<hr />config: " + config);
            });
    }
//#endregion "Reference Tables"
}

